export default __webpack_public_path__ + "static/media/tick-circle.55c3f716.svg";